/* eslint-disable no-param-reassign */
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  signedIn: false,
  token: null,
  refreshToken: null
};

const sessionSlice = createSlice({
  name: `auth/session`,
  initialState,
  reducers: {
    signInSuccess(state, action) {
      state.signedIn = true;
      // Support both object payload {access, refresh} or string (access token only for backward compat)
      if (typeof action.payload === 'object') {
        state.token = action.payload.access || action.payload.token;
        state.refreshToken = action.payload.refresh || action.payload.refreshToken;
      } else {
        state.token = action.payload;
      }
    },
    signOutSuccess(state) {
      state.signedIn = false;
      state.token = null;
      state.refreshToken = null;
    },
    // Used after a successful /auth/jwt/refresh/. The refresh field may be
    // absent — only some backends rotate refresh tokens on every refresh. When
    // it IS present, persisting it is mandatory; the old one is invalidated
    // server-side and any subsequent refresh attempts would 401.
    tokenRefreshed(state, action) {
      const { access, refresh } = action.payload || {};
      if (access) state.token = access;
      if (refresh) state.refreshToken = refresh;
    }
  }
});

export const { signInSuccess, signOutSuccess, tokenRefreshed } =
  sessionSlice.actions;

export default sessionSlice.reducer;
